import {
  MultiSelectFilterInputComponent
} from '../components/filter-inputs/multi-select-filter-input/multi-select-filter-input.component';
import { SelectFilterInputComponent } from '../components/filter-inputs/select-filter-input/select-filter-input.component';
import { DateFilterInputComponent } from '../components/filter-inputs/date-filter-input/date-filter-input.component';
import { FilterItemConfig, } from '../../types/filter-config';
import { FilterOperator } from '../../types/filter-operators';
import { FilterInputBase } from '../components/filter-inputs/filter-input.base';
import { Type } from '@angular/core';

// The switch narrows the `operator` *value*, but not the type parameter `TOperator`, and
// FilterInputBase is invariant in TOperator (InputSignal carries a transformFn: (v) => v).
// So the compiler can't prove the concrete component matches FilterInputBase<T, TOperator>,
// even though the runtime branch guarantees it — hence the casts.
export const defaultFilterInputTypeFactory =
  <T extends object, TOperator extends FilterOperator>
  (type: FilterItemConfig<any>['type'], operator: TOperator): Type<FilterInputBase<T, TOperator>> => {
  const isDate = type === 'date' || type === 'dateTime' || type === 'dateTimeTz';
  switch (operator) {
    case 'in':
    case 'notIn':
      return MultiSelectFilterInputComponent<T, any> as unknown as Type<FilterInputBase<T, TOperator>>;
    case 'equals':
    case 'notEquals':
      if(type === 'entity')
        return SelectFilterInputComponent<T> as unknown as Type<FilterInputBase<T, TOperator>>;
      if(isDate)
        return DateFilterInputComponent<T> as unknown as Type<FilterInputBase<T, TOperator>>;
      break;
    case 'before':
    case 'after':
    case 'beforeOrEquals':
    case 'afterOrEquals':
    case 'between':
      if(isDate)
        return DateFilterInputComponent<T> as unknown as Type<FilterInputBase<T, TOperator>>;
      break;
  }
  throw new Error(`Operator ${operator} not supported`);
}
